import { useState } from "react";
import "./SetPassword.css";

export default function SetPassword({ email, onDone }) {
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const handleSetPassword = async () => {
        setError("");
        setSuccess("");

        if (!password || !confirm) {
            setError("Please fill both fields.");
            return;
        }
        if (password !== confirm) {
            setError("Passwords do not match.");
            return;
        }

        const res = await fetch("https://sda-chat-api-d3eeg6hcewf8gdde.ukwest-01.azurewebsites.net/auth/set-password", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password })
        });

        const data = await res.json();

        if (res.ok) {
            setSuccess("Password saved! You can now log in.");
            setTimeout(() => {
                onDone();   // back to login
            }, 1500);
        } else {
            setError(data.error || "Something went wrong");
        }
    };

    return (
        <div className="setpass-wrapper">
            <div className="setpass-card">
                <h1>Create Your Password</h1>
                <p className="email-text">{email}</p>

                {error && <div className="setpass-error">{error}</div>}
                {success && <div className="setpass-success">{success}</div>}

                <input 
                    type="password"
                    placeholder="New password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />

                <input 
                    type="password"
                    placeholder="Confirm password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                />

                <button onClick={handleSetPassword}>Save Password</button>
            </div>
        </div>
    );
}